import { useGet } from '../../../sharedModules/hooks/useQuery';
import { CollectionEmailSendDetail } from '../model';

export function useCollectionEmailSend(
  id: number | null,
  emailType: 'collection' | 'statement' = 'collection',
  location?: string,
) {
  return useGet<CollectionEmailSendDetail>({
    url: id ? `/collections/email_sends/${id}` : '',
    params: { email_type: emailType, ...(location ? { location } : {}) },
    enabled: !!id,
  });
}
